import { z } from 'zod';
import superjson from 'superjson';
import { IntegrationProviderArrayValues } from '../../helpers/schema';

export const schema = z.object({
  provider: z.enum(IntegrationProviderArrayValues),
});

export type InputType = z.infer<typeof schema>;

export type OutputType = {
  success: boolean;
  message?: string;
};

export const postDeleteIntegration = async (
  body: InputType,
  init?: RequestInit,
): Promise<OutputType> => {
  const validatedInput = schema.parse(body);
  const result = await fetch(`/_api/integrations/delete`, {
    method: 'POST',
    credentials: 'include',
    body: superjson.stringify(validatedInput),
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers ?? {}),
    },
  });

  if (!result.ok) {
    const errorObject = superjson.parse<{ error: string }>(await result.text());
    throw new Error(errorObject.error);
  }

  return superjson.parse<OutputType>(await result.text());
};
